import { createAggrApiInstance } from '@/utils/api/axiosInstance'
import { handleApiStatus } from '@/utils/api/handleAPI'

import * as aggr from '@/api-generator/aggr/index'

const feCompanyOrganizationStatsApi = createAggrApiInstance(aggr.FrontendCompanyOrgStatsApi)

export const queryTagStatsClicks = async (reqData: aggr.QueryAllSubTagClicksRq) => {
  const res = await handleApiStatus(() => feCompanyOrganizationStatsApi.companyorgstatsQueryallsubtagclicks(reqData))
  return res
}

export const getSubTagInfo = async (reqData: aggr.CompanyOrgStatsQueryRq) => {
  const res = await handleApiStatus(() => feCompanyOrganizationStatsApi.companyorgstatsQuerysubtaginfo(reqData))
  return res
}

export const getSubTagClicks = async (reqData: aggr.CompanyOrgStatsClicksRq) => {
  const res = await handleApiStatus(() => feCompanyOrganizationStatsApi.companyorgstatsClicks(reqData))
  return res
}

export const getSubTagAgeDistribution = async (reqData: aggr.CompanyOrgStatsQueryRq) => {
  const res = await handleApiStatus(() => feCompanyOrganizationStatsApi.companyorgstatsAgedist(reqData))
  return res
}

export const getSubTagGenderDistribution = async (reqData: aggr.CompanyOrgStatsQueryRq) => {
  const res = await handleApiStatus(() => feCompanyOrganizationStatsApi.companyorgstatsGenderdist(reqData))
  return res
}

export const getSubTagDeviceDistribution = async (reqData: aggr.CompanyOrgStatsQueryRq) => {
  const res = await handleApiStatus(() => feCompanyOrganizationStatsApi.companyorgstatsDevicedist(reqData))
  return res
}

export const getSubTagRegionDistribution = async (reqData: aggr.CompanyOrgStatsQueryRq) => {
  const res = await handleApiStatus(() => feCompanyOrganizationStatsApi.companyorgstatsRegiondist(reqData))
  return res
}

export const getSubTagSourceDistribution = async (reqData: aggr.CompanyOrgStatsQueryRq) => {
  const res = await handleApiStatus(() => feCompanyOrganizationStatsApi.companyorgstatsSourcedist(reqData))
  return res
}

export const getSubTagOverlap = async (reqData: aggr.AnalyzeTagOverlapRq) => {
  const res = await handleApiStatus(() => feCompanyOrganizationStatsApi.companyorgstatsAnalyzetagoverlap(reqData))
  return res
}

export const getSubTagOverlapViewTopUrlCodeList = async (reqData: aggr.AnalyzeTagOverlapRq) => {
  const res = await handleApiStatus(() =>
    feCompanyOrganizationStatsApi.companyorgstatsAnalyzecompareoverlapsessionviewurlcodetop(reqData)
  )
  return res
}
